import axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { ManageCutOffViewModel } from "./ManageCutOffViewModel";
import { cutOffTimeUrls } from "../../URL/ApplicationUrls";
import { combinedUrls } from "../../URL/functions";

export const saveChanges = async (dataChanges: ManageCutOffViewModel[]) => {
  const url = combinedUrls(cutOffTimeUrls.base.apiUrl, "Save");
  const data = {
    originRegions: dataChanges,
  };
  try {
    const response: AxiosResponse = await axios.put(url, data);
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    toast("Saving CutOff was successful", {
      type: "success",
    });
  } catch {
    toast("Error while saving CutOff", {
      type: "error",
    });
  }
};
